export default interface SchedaBudgetDataClass {
    id: number;
    loading: boolean;
    informazioniCostiDiAvvio: InformazioniCostiDiAvvioDataClass;
    //contoEconomico: ContoEconomicoDataClass;
    //forfetario: ForfetarioDataClass;
    iscrizioneRegistroImprese: IscrizioneRegistroImpreseDataClass;
    dirittiCCIAA: DirittiCCIAADataClass;
    iscrizioneImpreseArtigiane: IscrizioneImpreseArtigianeDataClass;
    contoEconomicoProfessionista: ContoEconomicoProfessionistaDataClass;
    contoEconomicoDittaSocieta: ContoEconomicoDittaSocietaDataClass;
    inail: InailDataClass;
    imposteContributi: ImposteContributiDataClass;
    dettagli: DettagliDataClass;
    forfetari: ForfetariDataClass;
}

export function SRL_TRASPARENTE(state: SchedaBudgetDataClass) {
    return state.informazioniCostiDiAvvio.tipologia === "SRL_TRASPARENTE" || state.informazioniCostiDiAvvio.tipologia === "SOCIETA_DI_PERSONE";
}

export function SRL_NON_TRASPARENTE(state: SchedaBudgetDataClass) {
    return state.informazioniCostiDiAvvio.tipologia === "SRL_NON_TRASPARENTE";
}

export function IMPRESA_FAMILIARE(state: SchedaBudgetDataClass) {
    return state.informazioniCostiDiAvvio.tipologia === "IMPRESA_FAMILIARE";
}

export function PROFESSIONE(state: SchedaBudgetDataClass) {
    return state.informazioniCostiDiAvvio.tipologia === "PROFESSIONE";
}

export function IMPRENDITORE(state: SchedaBudgetDataClass) {
    return state.informazioniCostiDiAvvio.tipologia === "IMPRESA";
}

export function IMPRESA(state: SchedaBudgetDataClass) {
    return state.informazioniCostiDiAvvio.tipologia === "IMPRESA" || state.informazioniCostiDiAvvio.tipologia === "IMPRESA_FAMILIARE" ||
        state.informazioniCostiDiAvvio.tipologia === "SRL_TRASPARENTE" || state.informazioniCostiDiAvvio.tipologia === "SRL_NON_TRASPARENTE" ||
        state.informazioniCostiDiAvvio.tipologia === "SOCIETA_DI_PERSONE";
}

export function IsRegimeForfetario(state: SchedaBudgetDataClass) {
    return state.informazioniCostiDiAvvio.regime === "FORFETARIO";
}

export function IsRegimeNormale(state: SchedaBudgetDataClass) {
    return state.informazioniCostiDiAvvio.regime === "NORMALE";
}

export interface DettagliDataClass {
    E32_contributi: number;
    D32_quota: number;
    E28_contributi: number;
    D28_quota: number;
    D29_quota: number;
    E29_contributi: number;
    D30_quota: number;
    E30_contributi: number;
    E31_contributi: number;
    D31_quota: number;
    E27_contributi: number;
    D27_quota: number;
    F22_irpef_add: number;
    E22_contributi: number;
    D22_quota: number;
    F21_irpef_add: number;
    E21_contributi: number;
    D21_quota: number;
    F20_irpef_add: number;
    E20_contributi: number;
    D20_quota: number;
    F19_irpef_add: number;
    E19_contributi: number;
    D19_quota: number;
    F18_irpef_add: number;
    E18_contributi: number;
    D18_quota: number;
    F17_irpef_add: number;
    E17_contributi: number;
    D17_quota: number;
    F12_irpef_add: number;
    E12_contributi: number;
    D12_quota: number;
    F11_irpef_add: number;
    E11_contributi: number;
    D11_quota: number;
    F10_irpef_add: number;
    E10_contributi: number;
    D10_quota: number;
    F9_irpef_add: number;
    E9_contributi: number;
    D9_quota: number;
    F8_irpef_add: number;
    E8_contributi: number;
    D8_quota: number;
    F7_irpef_add: number;
    E7_contributi: number;
    D7_quota: number;
}

export interface GruppoDiSettoreDataClass {
    D46_reddito: number, 
    gruppo: string,
}
export interface ForfetariDataClass {
    // D46_reddito: number;
    // gruppoDiSettore: string;
    gruppoDiSettore: GruppoDiSettoreDataClass;
    tipologia: string;
    B23_B26_riduzione_35: boolean;
    B28_professionista_senza_cassa_al_24: boolean;
    B29_professionista_senza_cassa_al_25_72: boolean;
    B30_professionista_con_cassa_autonoma: boolean;
    altriDati: string;
    B32_impostaSostitutiva: boolean;
    B34_impresa_familiare_1_collaboratore: boolean;
    B35_rivalsa_contributi_ivs: boolean;
    D30_professionista_con_cassa_autonoma_percentuale: number;
    D56_ricavi_compensi: number;
    D58_reddito: number;
    D60_contributi_previdenziali: number;
    D62_rivalsa_contributi: number;
    D64_imponibile: number;
    D66_imposta_sostitutiva: number;
    D69_diritto_annuale_cciaa: number;
    D70_inail: number;
    D72_totale_imposta_contributi_oneri: number;
    D74_reddito_netto_disponibile: number;
    C49_altri_dati: string;
    C50_altri_dati: string;
    C51_altri_dati: string;
    C52_altri_dati: string;
    C53_altri_dati: string;
    D94: number;
    D95: number;
    D96: number;
    D97: number;
}

export interface InformazioniCostiDiAvvioDataClass {
    E52_totale_costi_iniziali: number;
    I51_consulenze_interne: number;
    F51_consulenze_esterne_provvigioni: number;
    E51_parziali_spese_vive: number;
    nomeDitta: string;
    tipologia: string;
    attivita: string;
    regime: string;
    E16_fabbricato: number,
    E17_macchinari: number,
    E18_attrezzature: number,
    E19_macchinari: number,
    E20_mobili: number,
    E21_furgoni: number,
    E22_autovetture: number,
    E23_immateriali: number,
    E24_altro: number,
    E25_totale: number,
    E37_speseVive_AcquistoAzienda: number,
    F37_consEst_AcquistoAzienda: number,
    I37_consInt_AcquistoAzienda: number,
    E38_speseVive_AffittoAzienda: number,
    F38_consEst_AffittoAzienda: number,
    I38_consInt_AffittoAzienda: number,
    E39_speseVive_AttoCostSocieta: number,
    F39_consEst_AttoCostSocieta: number,
    I39_consInt_AttoCostSocieta: number,
    E40_speseVive_IscrizioneRegistroImprese: number,
    F40_consEst_IscrizioneRegistroImprese: number,
    I40_consInt_IscrizioneRegistroImprese: number,
    E41_speseVive_IscrizioneAlbo: number,
    F41_consEst_IscrizioneAlbo: number,
    I41_consInt_IscrizioneAlbo: number,
    E42_speseVive_AutorizzazioniPermessi: number,
    F42_consEst_AutorizzazioniPermessi: number,
    I42_consInt_AutorizzazioniPermessi: number,
    E43_speseVive_Locali: number,
    F43_consEst_Locali: number,
    I43_consInt_Locali: number,
    E44_speseVive_Privacy: number,
    F44_consEst_Privacy: number,
    I44_consInt_Privacy: number,
    E45_speseVive_Dlgs812008: number,
    F45_consEst_Dlgs812008: number,
    I45_consInt_Dlgs812008: number,
    E46_speseVive_HACCP: number,
    F46_consEst_HACCP: number,
    I46_consInt_HACCP: number,
    E47_speseVive_Ambiente: number,
    F47_consEst_Ambiente: number,
    I47_consInt_Ambiente: number,
    E48_speseVive_Informatici: number,
    F48_consEst_Informatici: number,
    I48_consInt_Informatici: number,
    E49_speseVive_Altro1: number,
    F49_consEst_Altro1: number,
    I49_consInt_Altro1: number,
    E50_speseVive_Altro2: number,
    F50_consEst_Altro2: number,
    I50_consInt_Altro2: number,
    K16_fabbricato: number,
    K17_macchinari: number,
    K18_attrezzature: number,
    K19_macchinari: number,
    K20_mobili: number,
    K21_furgoni: number,
    K22_autovetture: number,
    K23_immateriali: number,
    K24_altro: number,
    K25_totale: number
}

// export interface ContoEconomicoDataClass {
// }

export interface ImposteContributiDataClass {
    H62_irap: number;
    J214_aliquota_ires: number;
    F215_quota5socio: number;
    F214_quota4socio: number;
    F213_quota3socio: number;
    F212_quota2socio: number;
    F211_quota1socio: number;
    F208_artigiano: boolean;
    F209_commerciante: boolean;
    F210_NOIVS: boolean;
    J165_pfigli: number;
    I165_nfigli: number;
    H165_coniuge: boolean;
    J164_pfigli: number;
    I164_nfigli: number;
    H164_coniuge: boolean;
    J163_pfigli: number;
    I163_nfigli: number;
    H163_coniuge: boolean;
    J162_pfigli: number;
    I162_nfigli: number;
    H162_coniuge: boolean;
    J161_pfigli: number;
    I161_nfigli: number;
    H161_coniuge: boolean;
    F166_totale: number;
    C164_no_contributi: boolean;
    F164_quota_socio: number;
    F165_quota_socio: number;
    C165_no_contributi: boolean;
    F163_quota_socio: number;
    C163_no_contributi: boolean;
    F162_quota_socio: number;
    C162_no_contributi: boolean;
    F161_quota_socio: number;
    C161_no_contributi: boolean;
    F157_nsoci: number;
    F155_commerciante: boolean;
    F154_artigiano: boolean;
    J111_pfigli: number;
    I111_nfigli: number;
    H111_coniuge: boolean;
    J110_pfigli: number;
    I110_nfigli: number;
    H110_coniuge: boolean;
    J109_pfigli: number;
    I109_nfigli: number;
    H109_coniuge: boolean;
    J108_pfigli: number;
    I108_nfigli: number;
    H108_coniuge: boolean;
    H107_coniuge: boolean;
    J107_pfigli: number;
    I107_nfigli: number;
    F112_totale: number;
    RicalcolaQuoteCollab: boolean;
    RicalcolaQuoteSoci: boolean;
    F111_quota_collab: number;
    F110_quota_collab: number;
    F109_quota_collab: number;
    F108_quota_collab: number;
    C111_21anni: boolean;
    C110_21anni: boolean;
    C109_21anni: boolean;
    C108_21anni: boolean;
    F107_quota_titolare: number;
    F103_ncollaboratori: number;
    F101_commerciante: boolean;
    F100_artigiano: boolean;
    J83_detrazioni: number;
    H83_imposta_lorda: number;
    F83_imponibile: number;
    D83_contributi: number;
    G80_con_cassa_autonoma: number;
    F80_con_cassa_autonoma: boolean;
    H78_coniuge: boolean;
    J78_pfigli: number;
    I78_nfigli: number;
    F78_senzacassaal2598: boolean;
    F77_senzacassaal24: boolean;
    J69_pfigli: number;
    I69_nfigli: number;
    H69_coniuge: boolean;
    F69_commerciante: boolean;
    F68_artigiano: boolean;
    H59_irap: number;
    E62_imponibile_irap: number;
    E59_imponibile_irap: number;
    H61_deduzioni: number;
    H58_deduzioni: number;
    E61_valore_della_produzione: number;
    E58_valore_della_produzione: number;
    F55_aliquota: number;
    F53_assenza_di_autonoma_organizzazione: boolean;
    J45_reddito_ai_fini_fiscali_e_contributivi: number;
    J44_reddito_ai_fini_fiscali_e_contributivi: number;
    J84_irpef_netta: number;
    J85_addiz_reg_com: number;
    J89_totale: number;
    D90_contributi: number;
    F90_imponibile: number;
    H90_imposta_lorda: number;
    J91_irpef_netta: number;
    J92_addiz_reg_com: number;
}

export interface InailDataClass {
    E27_premio_inail: number;
    D27_n_persone_assicurate: number;
    C27_tassox1000: number;
    E19_premio_inail: number;
    D19_n_persone_assicurate: number;
    C19_classe_di_rischio: number;
    // ArtigianoIndustria: string;
}

export interface ContoEconomicoDittaSocietaDataClass {
    tipologia_inail: string,
    J59_reddito_disponibile: number;
    J48_totale: number;
    J57_contributi_previdenziali_titolare_collaboratori_soci: number;
    J55_totale: number;
    G55_irpef_addizionali: number;
    G54_ires: number;
    G53_irap: number;
    J50_risultato_netto: number;
    G48_interessi_attivi_cc_titoli_ecc: number;
    G47_interessi_passivi_cc_mutui_ecc: number;
    J44_risultato_operativo: number;
    J42_affitto_figurativo: number;
    J41_totale: number;
    G41_altro: number;
    D41_altro: string;
    G40_diritto_ann_cciaa: number;
    G39_inail: number;
    G38_quote_associative: number;
    G37_illuminazione: number;
    G36_assicurazioni: number;
    G35_affitto_uffici: number;
    G34_spese_telefoniche: number;
    G33_compenso_agli_amministratori: number;
    G32_servizi_contabili: number;
    J30_impiegati_salari_contrib_ecc: number;
    J26_margine_della_produzione: number;
    J24_totale_costi_diretti_della_produzione: number;
    J22_totale: number;
    D22_altro: string;
    G22_altro: number;
    G21_manutenzioni_riparazioni: number;
    G20_energia_fm_combustibili_ecc: number;
    G19_affitto_locali_produzione: number;
    J16_spese_per_lavorazioni_presso_terzi: number;
    J15_salario_figurativo_titolare_soci_collaboratori: number;
    J14_mano_d_opera_salari_contr_ecc: number;
    J13_costo_dei_beni_impiegati_per_produrre_i_ricavi: number;
    J10_ricavi_della_produzione_servizio: number;
}

export interface ContoEconomicoProfessionistaDataClass {
    J99_Reddito_Disponibile: number;
    J97_contributi_previdenziali: number;
    J94_totale: number;
    G94_irpef_addizionali: number;
    G93_irap: number;
    J90_Risultato_Netto: number;
    J88_Totale_Costi: number;
    G86_Altro_Valore: number;
    //D86_Altro_Descrizione: string;
    G85_Interessi_Passivi: number;
    G84_Carburanti: number;
    G83_Agg_Profess: number;
    G82_Assicurazioni: number;
    G81_Affitto_Locali: number;
    G80_Spese_Telefoniche: number;
    G79_Servizi_Contabili: number;
    G77_Riparazioni: number;
    G76_Energia: number;
    J74_Compensi_Terzi: number;
    J73_Dipendenti: number;
    J70_Compensi: number;
}

//export interface ForfetarioDataClass {
//}

export interface IscrizioneRegistroImpreseDataClass {
    J30_altro: number;
    I28_imposta_di_bollo: boolean;
    J28_imposta_di_bollo: number;
    I26_maggiorazione: boolean;
    J26_maggiorazione: number;
    I24_su_supporto_informatico_digitale_o_per_via_telematica: boolean;
    J24_su_supporto_informatico_digitale_o_per_via_telematica: number;
    J20_altro: number;
    I18_imposta_di_bollo_societa_di_capitali: boolean;
    J18_imposta_di_bollo_societa_di_capitali: number;
    I17_imposta_di_bollo_societa_di_persone: boolean;
    J17_imposta_di_bollo_societa_di_persone: number;
    I15_maggiorazione: boolean;
    J15_maggiorazione: number;
    I13_riduzione_del_50_per_le_cooperative_sociali: boolean;
    I11_con_modalita_telematica: boolean;
    J11_con_modalita_telematica: number;
    I10_su_supporto_informatico_digitale: boolean;
    J10_su_supporto_informatico_digitale: number;
}

export interface DirittiCCIAADataClass {
    B8_check: boolean;
    B9_check: boolean;
    B10_check: boolean;
    B11_check: boolean;
    B12_check: boolean;
    B13_check: boolean;
    B14_check: boolean;
    B15_check: boolean;

    H8_sede_principale: number;
    H9_sede_principale: number;
    H10_sede_principale: number;
    H11_sede_principale: number;
    H12_sede_principale: number;
    H13_sede_principale: number;
    H14_sede_principale: number;
    H15_sede_principale: number;

    I8_maggiorazione: number;
    I9_maggiorazione: number;
    I10_maggiorazione: number;
    I11_maggiorazione: number;
    I12_maggiorazione: number;
    I13_maggiorazione: number;
    I14_maggiorazione: number;

    J8_numero_unita_locali: number;
    J9_numero_unita_locali: number;
    J10_numero_unita_locali: number;
    J11_numero_unita_locali: number;
    J12_numero_unita_locali: number;
    J13_numero_unita_locali: number;
    J14_numero_unita_locali: number;

    M16_totale: number;
}

export interface IscrizioneImpreseArtigianeDataClass {
    C45_altro: string;
    J45_altro: number;
    I43_maggiorazione_per_societa: boolean;
    J43_maggiorazione_per_societa: number;
    I42_maggiorazione_per_impresa_individuale: boolean;
    J42_maggiorazione_per_impresa_individuale: number;
    J40_digita_importo: number;
}